const ecosystem = ['Microsoft', 'Apple', 'Google']

export default ecosystem